export default __webpack_public_path__ + "static/media/hall_of_fame_star.fb5035b1.png";